import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { CtaBlock } from "@/components/CtaBlock";
import { ArrowRight } from "lucide-react";
import { MOBILITA_PAGES } from "@/data/site";

export default function MobilitaHub() {
  const entries = Object.entries(MOBILITA_PAGES);
  return (
    <>
      <Seo title="Mobilità senior — Soluzioni per anziani e mobilità ridotta"
        description="Guide alle soluzioni di mobilità per anziani: scooter elettrici, veicoli coperti, mezzi senza patente e alternative alla microcar."
        keywords="mobilità senior, veicoli per anziani, scooter elettrico anziani" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Mobilità" }]} /></div>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
        <span className="uppercase text-xs font-bold tracking-widest text-emerald-800 bg-emerald-100 px-3 py-1 rounded-full">Mobilità senior</span>
        <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Soluzioni di mobilità per anziani e mobilità ridotta</h1>
        <p className="mt-4 text-lg sm:text-xl text-slate-600 max-w-2xl">Esplora le principali soluzioni di mobilità e scopri perché sempre più famiglie scelgono un dispositivo medico monoposto come SENIORCAR, senza patente né targa.</p>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {entries.map(([slug, p]) => (
            <Link key={slug} to={`/mobilita/${slug}`} className="rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md hover:-translate-y-1 transition-all group" data-testid={`mobilita-link-${slug}`}>
              <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-800 leading-snug" style={{ fontFamily: "Outfit" }}>{p.title}</h3>
              <p className="mt-1.5 text-slate-600 text-sm line-clamp-2">{p.answer}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-emerald-800 font-semibold text-sm">Approfondisci <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16"><CtaBlock variant="discover" /></section>
    </>
  );
}
